// extension values
export const WITNESS_LINE_GAP = 6;
export const TICK_EXT = 3;
export const DIM_EXT = 1.5;
